export default __webpack_public_path__ + "static/media/sports15.c2c6154e.jpg";